import {
	SET_LAZY_GOALS_STATE,
	RESET,
	type SetLazyGoalsStateAction,
	type ResetAction,
} from './actions';
import type { GoalsState } from './types';

const initialState: GoalsState = {
	goalARIs: [],
	lazyGoalsByARI: {},
	isError: false,
	searchesInProgress: 0,
};

type Action = SetLazyGoalsStateAction | ResetAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: GoalsState = initialState, action: Action): GoalsState => {
	switch (action.type) {
		case SET_LAZY_GOALS_STATE:
			return {
				...state,
				...action.payload,
			};
		case RESET:
			return action.payload;
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
